// BottomItemQuantityPage.js
import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Export from "../../../../components/Export";

const BottomItemQuantityPage = ({
  objects,
  itemDataQuantity,
  range,
  storess,
  getChartOptionsBottomQuantity,
  printChart,
  exportToCSV,
  formatSales,
}) => {
  // Safely extract “YYYY-MM-DD” from range.tran_date
  const formattedStart = range?.tran_date?.["$gte"]?.split("T")[0] ?? "";
  const formattedEnd = range?.tran_date?.["$lte"]?.split("T")[0] ?? "";

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="fw-bold mt-3 text-capitalize text-black">
          Bottom&nbsp;
          <span style={{ color: "#83c14a" }}>Menu Items</span>&nbsp; by&nbsp;
          <span style={{ color: "#D1DE48" }}>Sold Quantity</span>
        </h1>

        <Export
          exportPdf={() => printChart("chart-container-bottom-quantity")}
          exportCsv={() => exportToCSV("quantity", false, 1000)}
        />
      </div>

      {objects?.length > 0 ? (
        <div id="chart-container-bottom-quantity" className="chart-container">
          <div className="card">
            <HighchartsReact
              highcharts={Highcharts}
              options={getChartOptionsBottomQuantity}
            />
          </div>

          <div className="print-only-content">
            <h2>Report Details</h2>
            <div className="d-flex justify-content-between align-items-center print-only-content">
              <h3>Brand: Angels Pizza</h3>
              <h4 className="mx-auto"></h4>
              <h3>Store: {storess}</h3>
              <h3>
                Date Range:&nbsp;
                <span>{formattedStart}</span>&nbsp;
                <span>{formattedEnd}</span>
              </h3>
              <h3>Bottom Menu Items by Sold Quantity</h3>
            </div>
            <div className="print-only" style={{ fontSize: "20px" }}>
              <table className="table text-center">
                <thead>
                  <tr className="d-flex">
                    <th>Menu Item</th>
                    <th className="ms-5">Sold Quantity</th>
                    <th className="ms-5">Revenue</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(itemDataQuantity)
                    .sort((a, b) => a[1].quantity - b[1].quantity)
                    .slice(0, 100)
                    .map(([itemCode, itemDetails]) => (
                      <tr key={itemCode}>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {itemDetails.description}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {itemDetails.quantity}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          {formatSales(itemDetails.sales)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center align-items-center mt-4">
          <img
            src="./choosefirst.png"
            style={{ height: "200px", width: "200px" }}
            alt="Please select a date first"
          />
          <h4>To proceed, please select a date firstsss</h4>
        </div>
      )}
    </div>
  );
};

export default BottomItemQuantityPage;
